import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { getCaseSettingData } from '@modules/appraisalAdmin/selectors/letterCaseSetting';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

const CustomTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#efeffd',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '14px',
    border: '1px solid #dadde9',
    maxWidth: '600px',
    borderRadius: '16px',
    fontFamily: 'Arial',
  },
}))(Tooltip);

const SidebarCaseSettingWidget = ({ style }) => {
  const caseSetting = useSelector(getCaseSettingData);
  return (
    <SidebarCaseSettingWidget.Wrapper>
      <CustomTooltip
        title={
          <SidebarCaseSettingWidget.ToolTipContentContainer>
            <div>Letter Case Data Entry Setting: <span>{caseSetting === 'All Uppercase' ? 'ALL UPPERCASE' : 'UPPER/LOWER CASE'}</span></div>
          </SidebarCaseSettingWidget.ToolTipContentContainer>
        }
      >
        <SidebarCaseSettingWidget.Button style={style ? style : {}} caps={caseSetting === 'All Uppercase'}>
          <span>A</span><span>a</span>
        </SidebarCaseSettingWidget.Button>
      </CustomTooltip>
    </SidebarCaseSettingWidget.Wrapper>
  );
};

SidebarCaseSettingWidget.propTypes = {
  style: PropTypes.any,
};

SidebarCaseSettingWidget.Wrapper = styled.div`
  width: 40px;
  height: 40px;
  cursor: pointer;

  i {
    font-size: 28px;
    color: ${(props) => props.theme.colors.lightGray};

    &:hover {
      color: ${(props) => props.theme.colors.softGray};
      transition: 0.3s;
    }
  }
`;

SidebarCaseSettingWidget.ToolTipContentContainer = styled.div`
  padding: 10px 10px 10px 10px;
  min-width: 300px;

  span {
    font-weight: bold;
  }
`;

SidebarCaseSettingWidget.Button = styled.div`
  font-size: 18px;
  font-weight: 400;
  height: 35px;
  width: 35px;
  border-radius: 100%;
  background: #eee;
  display: flex;
  justify-content: center;
  align-items: center;

  span:first-child{
    color: black;
  }
  span:nth-child(2){
    color: ${({ caps }) => caps ? 'lightgray' : 'black'};
  }
`;

export default SidebarCaseSettingWidget;
